import React, { useState } from "react";
import { Dimmer, Form, Grid, Loader } from "semantic-ui-react";
import Option from "./Option";

const OptionsList = (props) => {
  const { loading, horizontal, className } = props;
  const [focus, setFocus] = useState(null);

  if (loading) {
    return (
      <Dimmer inverted active>
        <Loader active />
      </Dimmer>
    );
  }

  if (horizontal) {
    return (
      <Form>
        <Form.Group inline className="mb-0">
          {props.options.map((option, index) => {
            return (
              <span className="mr-0_5">
                <Option
                  inline
                  option={option}
                  optionsList={props.options}
                  onChange={props.onChange}
                  onFocus={setFocus}
                  focus={focus}
                />
              </span>
            );
          })}
        </Form.Group>
      </Form>
    );
  }

  return (
    <Grid columns={2} relaxed className={className}>
      {props.prefix}
      {props.options.map((option, index) => {
        const style = option.isHidden ? { display: "none " } : {};
        const expanded = props.labelWidth || 7;

        return (
          <Grid.Row key={`${option.code}_${index}`} style={style}>
            <Grid.Column width={expanded}>
              <b>{option.text}</b>:{" "}
              {option.isRequired && <span style={{ color: "#db2828" }}>*</span>}
            </Grid.Column>
            <Grid.Column width={16 - expanded}>
              <Option
                option={option}
                optionsList={props.options}
                onChange={props.onChange}
                onFocus={setFocus}
                focus={focus}
              />
            </Grid.Column>
          </Grid.Row>
        );
      })}
    </Grid>
  );
};

export default OptionsList;
